import { useNavigate } from "react-router-dom";
import BrandLogo from "@/components/BrandLogo";
import { toast } from "sonner";
import { LogOut, Settings as SettingsIcon, LayoutGrid } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import ThemeToggle from "@/components/ThemeToggle";
import NotificationBell from "@/components/NotificationBell";

export default function AppHeader({ title }) {
  const nav = useNavigate();
  const { user, logout } = useAuth();

  const doLogout = async () => {
    await logout();
    toast.success("Signed out");
    nav("/login", { replace: true });
  };

  return (
    <header className="sticky top-0 z-40 glass border-b" style={{ borderColor: "var(--border)" }}>
      <div className="max-w-[1500px] mx-auto px-3 sm:px-6 h-14 flex items-center justify-between gap-2 sm:gap-3">
        <div className="flex items-center gap-4 min-w-0">
          <button data-testid="header-logo" onClick={() => nav("/dashboard")}
            className="font-display font-black tracking-tighter shrink-0">
            <BrandLogo compact />
          </button>
          {title && <span className="hidden sm:inline text-xs tracking-[0.25em] uppercase font-bold truncate" style={{ color: "var(--text-2)" }}>/ {title}</span>}
        </div>
        <div className="flex items-center gap-1 sm:gap-2 shrink-0">
          <button data-testid="header-modules" onClick={() => nav("/dashboard")}
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-full glass flex items-center justify-center hover:scale-110 transition-transform" aria-label="Modules">
            <LayoutGrid className="w-4 h-4 text-primary-c" />
          </button>
          <button data-testid="header-settings" onClick={() => nav("/settings")}
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-full glass flex items-center justify-center hover:scale-110 transition-transform" aria-label="Settings">
            <SettingsIcon className="w-4 h-4 text-primary-c" />
          </button>
          <NotificationBell />
          <ThemeToggle />
          <div className="hidden sm:flex items-center gap-2 pl-2">
            <span className="text-sm font-semibold truncate max-w-[120px]">{user?.name || user?.email}</span>
          </div>
          <button data-testid="header-logout" onClick={doLogout}
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-full glass flex items-center justify-center hover:scale-110 transition-transform" aria-label="Logout">
            <LogOut className="w-4 h-4 text-primary-c" />
          </button>
        </div>
      </div>
    </header>
  );
}
